module.exports = "<div class=\"position-fixed bottom-0 end-0 p-3\">\r\n    <div id=\"toastContainer\"></div>\r\n  </div>\r\n<router-outlet></router-outlet>"